import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Typography,
  Button,
} from '@material-ui/core';
import { ErrorBoundary } from 'react-error-boundary';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import { MdOutlineUploadFile } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import KenDialog from '../../../global_components/KenDialogBox';
import RadioGroup from '@material-ui/core/RadioGroup';
import TermSelectionFilters from './TermSelectionFilters';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import ReactDOMServer from 'react-dom/server';
import {
  ACTIONS,
  SessionSchedulerContextProvider,
  useSessionSchedulerContext,
} from '../../../Context/sessionSchedulerContext';
import { getFacultyAndFacilty } from '../../../Utils/apiServices';
import Calendar from './Calendar';
import {
  CALENDAR_TYPES,
  EVENT_TYPE_OPTIONS,
  RESOURCE_TYPES_OPTIONS,
} from '../../../Utils/helper/schedulerHelper';
import KenCard from '../../../global_components/KenCard';
import SubjectSectionSelector from '../SessionScheduler/SubjectSectionSelector';
import KenButton from '../../../global_components/KenButton';
import routes from '../../../Utils/routes.json';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import { asBlob } from 'html-docx-js-typescript';
// import { saveAs } from 'file-saver';

export const useToggleStyles = makeStyles((theme) => ({
  root: {
    '&&': {
      display: 'inline-flex',
      // color: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenWhite,
      // boxShadow:
      //   '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      // '&:hover': {
      //   boxShadow: 'none',
      // },
    },
  },
  selected: {
    '&&': {
      // backgroundColor: theme.palette.KenColors.primary,
      backgroundColor: '#2C3E50',
      color: theme.palette.KenColors.kenWhite,
      '&:hover': {
        // backgroundColor: theme.palette.KenColors.primary,
        backgroundColor: '#1a252f',
        color: theme.palette.KenColors.kenWhite,
        boxShadow: 'none',
      },
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  card: {
    padding: 16,
  },
  label: {
    color: '#505F79',
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center',
  },
  legendPlanned: {
    color: '#fff',
    width: '70px',
    padding: '8px',
    borderRadius: '5px',
    backgroundColor: '#272727',
    textTransform: 'capitalize',
  },
  legendActual: {
    width: '70px',
    padding: '8px',
    borderRadius: '5px',
    color: '#272727',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
  },
}));

function Scheduler() {
  const [modeDownload, setModeDownload] = useState('');
  const [downloadDialog, setDowloadDialog] = useState(false);
  const [termOpt, setTermOpt] = useState([]);
  const [changeYear, setChangeYear] = useState('');
  const [changeIntake, setChangeIntake] = useState('');
  const [defaultDate, setDefaultDate] = useState();
  console.log('SessionScheduler 1');
  const history = useHistory();
  console.log(
    'params: ',
    new URLSearchParams(window.location.search).get('cType')
  );

  const {
    state: {
      term,
      resourceType,
      eventType,
      courseVersionData,
      calendarType,
      referenceActivities,
      sessions,
    },
    dispatch,
    fetchDataByTerm,
  } = useSessionSchedulerContext();

  const handleDownloadermode = (e) => {
    setModeDownload(e.target.value);
  };
  const toggleClasses = useToggleStyles();
  const classes = useStyles();
  const handleDownloadPdf = async () => {
    console.log(referenceActivities);
    console.log(sessions);
    if (modeDownload === 'Table') {
      const unit = 'pt';
      const size = 'A4'; // Use A1, A2, A3 or A4
      const orientation = 'portrait'; // portrait or landscape
      const marginLeft = 100;
      const doc = new jsPDF(orientation, unit, size);
      const termval = termOpt?.filter((item) => item.TermRecordId == term);
      const title = `Consolidated List for ${termval[0]?.label}`;
      doc.setFontSize(16);
      doc.text(title, marginLeft, 70);
      const headers = [
        [
          'Subject',
          'Section',
          'Start Date',
          'End Date',
          'Number of Sessions',
          'Facility Name',
          'Faculty Name',
        ],
      ];
      const res = sessions?.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate)
      );
      let group = [];
      let data = [];
      sessions.map((x, i) => {
        if (!group.includes(x.courseName)) {
          let groupData = sessions.filter((d) => d.courseName == x.courseName);
          console.log('groupData', groupData);
          let stDate = groupData.sort((a, b) => {
            return new Date(a.startDate) - new Date(b.startDate);
          });
          let enddt = [...groupData];
          let endDate = enddt.sort((a, b) => {
            return new Date(b.endDate) - new Date(a.endDate);
          });
          group.push(x.courseName);
          data.push([
            x.courseName,
            x.courseOfferingSectionId,
            stDate.length > 0 && stDate[0]?.startDate
              ? moment(stDate[0].startDate).format('DD/MM/YYYY')
              : '',
            endDate.length > 0 && endDate[0]?.endDate
              ? moment(endDate[0].endDate).format('DD/MM/YYYY')
              : '',
            // elt.endDate ? moment(elt.endDate).format("DD/MM/YYYY") : '',
            //`${x.startDate ? moment(x.startDate).format('LT') : ''}-${x.endDate ? moment(x.endDate).format('LT') : ''}`,
            groupData.length,
            x.facilityName,
            x.FacultyBooking.facultyName,
          ]);
        }
      });
      console.log('11111111222', group, data);
      console.log('11111111', res);
      // const data = res.map((elt) => [
      //   elt.startDate ? moment(elt.startDate).format('DD/MM/YYYY') : '',
      //   // elt.endDate ? moment(elt.endDate).format("DD/MM/YYYY") : '',
      //   `${elt.startDate ? moment(elt.startDate).format('LT') : ''}-${elt.endDate ? moment(elt.endDate).format('LT') : ''}`,
      //   elt.courseName,
      //   elt.FacultyBooking.facultyName,
      //   elt.facilityName,
      // ]);
      var finalY = doc.lastAutoTable.finalY || 40;
      let content = {
        theme: 'grid',
        startY: finalY + 60,
        head: headers,
        body: data,
      };
      console.log('pdf', data);
      doc.autoTable(content);
      doc.save('table.pdf');
    }
    if (modeDownload === 'View') {
      const unit = 'pt';
      const size = 'A4'; // Use A1, A2, A3 or A4
      const orientation = 'portrait'; // portrait or landscape
      const marginLeft = 100;
      const doc = new jsPDF(orientation, unit, size);
      const termval = termOpt?.filter((item) => item.TermRecordId == term);
      const title = `Detailed View for ${termval[0]?.label}`;
      doc.setFontSize(16);
      doc.text(title, marginLeft, 70);

      const headers = [
        [
          'Subject',
          'Section',
          'Start Date',
          'End Date',
          'Facility Name',
          'Faculty Name',
        ],
      ];
      const res = sessions?.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate)
      );
      let group = [];
      let data = [];
      sessions.map((x, i) => {
        // if (!group.includes(x.courseName)) {
        //   let groupData=sessions.filter(d=>d.courseName==x.courseName);
        //   console.log("groupData",groupData)
        //   let stDate=groupData.sort( (a, b) => {return new Date(a.startDate) - new Date(b.startDate)});
        //   let enddt=[...groupData];
        //   let endDate=enddt.sort( (a, b) =>{return new Date(b.endDate)- new Date(a.endDate)} );
        //   group.push(x.courseName)
        data.push([
          x.courseName,
          x.courseOfferingSectionId,
          // stDate.length>0&&stDate[0]?.startDate ? moment(stDate[0].startDate).format('DD/MM/YYYY') : '',
          // endDate.length>0&&endDate[0]?.endDate ? moment(endDate[0].endDate).format('DD/MM/YYYY') : '',
          x.startDate ? moment(x.endDate).format('DD/MM/YYYY') : '',
          x.endDate ? moment(x.endDate).format('DD/MM/YYYY') : '',
          // `${x.startDate ? moment(x.startDate).format('LT') : ''}-${x.endDate ? moment(x.endDate).format('LT') : ''}`,
          x.facilityName,
          x.FacultyBooking.facultyName,
        ]);
      });
      console.log('11111111222', group, data);
      console.log('11111111', res);
      // const data = res.map((elt) => [
      //   elt.startDate ? moment(elt.startDate).format('DD/MM/YYYY') : '',
      //   // elt.endDate ? moment(elt.endDate).format("DD/MM/YYYY") : '',
      //   `${elt.startDate ? moment(elt.startDate).format('LT') : ''}-${elt.endDate ? moment(elt.endDate).format('LT') : ''}`,
      //   elt.courseName,
      //   elt.FacultyBooking.facultyName,
      //   elt.facilityName,
      // ]);
      var finallY = doc.lastAutoTable.finallY || 40;
      let view = {
        theme: 'grid',
        startY: finallY + 60,
        head: headers,
        body: data,
      };
      console.log('pdf', data);
      doc.autoTable(view);
      doc.save('view.pdf');
    }
  };
  useEffect(() => {
    if (changeIntake || changeYear) {
      let getYear = new Date().getFullYear();
      let getMonth = new Date().getMonth();
      const month = [
        { label: 'JAN', value: '01' },
        { label: 'FEB', value: '02' },
        { label: 'MAR', value: '03' },
        { label: 'APR', value: '04' },
        { label: 'MAY', value: '05' },
        { label: 'JUN', value: '06' },
        { label: 'JUL', value: '07' },
        { label: 'AUG', value: '08' },
        { label: 'SEP', value: '09' },
        { label: 'OCT', value: '10' },
        { label: 'NOV', value: '11' },
        { label: 'DEC', value: '12' },
      ];
      const newMonth = month.filter((item) => item.label === changeIntake);
      var newDate = moment(
        `${newMonth[0]?.value || getMonth}-01-${changeYear || getYear}`
      ).format('LLL');
      console.log('newDate', newDate);
      setDefaultDate(newDate);
    }
  }, [changeIntake, changeYear]);
  useEffect(() => {
    fetchDataByTerm(term, {});
  }, [term]);

  const handleSubjectChange = (v) => {
    console.log('handleSubjectChange: ', v);
    // Dispatch selected subjects an alter events for this
    dispatch({
      type: ACTIONS.UPDATE_SELECTED_SUBJECTS,
      value: v,
    });
  };

  useEffect(() => {
    // get all faculty, facility and activity
    getFacultyAndFacilty()
      .then((res) => {
        if (res) {
          dispatch({
            type: ACTIONS.UPDATE_FACULTY_FACILITY_ACTIVITIES,
            value: res,
          });
        }
      })
      .catch((err) => {
        console.log('SessionScheduler: getFacultyAndFacilty: ', err);
      });

    // get calendar type from params and update
    const cType = new URLSearchParams(window.location.search).get('cType');
    if (Object.values(CALENDAR_TYPES).includes(cType)) {
      dispatch({ type: ACTIONS.SET_CALENDAR_TYPE, value: cType });
    }
  }, []);

  const hanldeBulkUpload = () => {
    history.push(routes.sessionPlanner);
  };
  const onDownloadPdf = () => {
    setDowloadDialog(true);
  };

  return (
    <div>
      <KenCard classes={classes.card}>
        <Grid container xs={12}>
          <Grid item lg={12} spacing={2}>
            <Grid container xs>
              <Grid item xs={12} lg={5}>
                <Typography variant="h6" color="primary" mb={2}>
                  <b>Academic Planning</b>
                </Typography>
              </Grid>
              <Grid item lg={2} />
              <Grid item xs={12} lg={3}>
                <Grid container xs={12}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    {/* <Typography className={classes.label}>Legend</Typography> */}
                    <div className={classes.legendPlanned}>Planned</div>
                    &nbsp;
                    <div className={classes.legendActual}>Actual</div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2}>
                <Button
                  variant="secondary"
                  style={{
                    marginRight: '10px',
                    border: '1px solid #272727',
                    float: 'right',
                    // textTransform: "capitalize"
                  }}
                  onClick={() => {
                    history.push({
                      pathname: `${routes.addSubject}`,
                    });
                  }}
                >
                  <ArrowBack />
                  Add Subject
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} spacing={2}>
            <Grid container xs={12}>
              <Grid item lg={5}>
                <TermSelectionFilters
                  onAcademicData={(v) => {
                    dispatch({ type: ACTIONS.UPDATE_ACADEMIC_DATA, value: v });
                  }}
                  onProgramChange={(v) => {
                    dispatch({ type: ACTIONS.UPDATE_PROGRAM, value: v });
                  }}
                  onYearChange={(v) => {
                    setChangeYear(v);
                    dispatch({ type: ACTIONS.UPDATE_YEAR, value: v });
                  }}
                  onIntakeChange={(v) => {
                    setChangeIntake(v);
                    dispatch({ type: ACTIONS.UPDATE_INTAKE, value: v });
                  }}
                  onTermChange={(v, termopt) => {
                    setTermOpt(termopt);
                    dispatch({ type: ACTIONS.UPDATE_TERM, value: v });
                  }}
                  setChangeYear={setChangeYear}
                  setChangeIntake={setChangeIntake}
                />
              </Grid>
              <Grid item lg={2} style={{ marginTop: 'auto' }}>
                <ToggleButtonGroup
                  size="small"
                  value={resourceType}
                  exclusive
                  onChange={(e, newValue) => {
                    dispatch({
                      type: ACTIONS.UPDATE_RESOURCE_TYPE,
                      value: newValue,
                    });
                  }}
                >
                  {RESOURCE_TYPES_OPTIONS.map((r) => (
                    <ToggleButton
                      classes={toggleClasses}
                      value={r.value}
                      aria-label={r.label}
                    >
                      {r.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Grid>
              {calendarType === CALENDAR_TYPES.ACADEMIC_PLANNER && (
                <Grid item lg={3} style={{ marginTop: 'auto' }}>
                  <ToggleButtonGroup
                    size="small"
                    color="primary"
                    exclusive
                    value={eventType}
                    onChange={(e, newValue) => {
                      dispatch({
                        type: ACTIONS.UPDATE_EVENT_TYPE,
                        value: newValue,
                      });
                    }}
                  >
                    {EVENT_TYPE_OPTIONS.map((r) => (
                      <ToggleButton
                        classes={toggleClasses}
                        value={r.value}
                        aria-label={r.label}
                        onClick={() => {}}
                      >
                        {r.label}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Grid>
              )}
              {calendarType === CALENDAR_TYPES.SESSIONS && (
                <Grid
                  item
                  lg={3}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                  }}
                >
                  <KenButton
                    variant="primary"
                    startIcon={<MdOutlineUploadFile />}
                    onClick={hanldeBulkUpload}
                    style={{ padding: 16 }}
                  >
                    Bulk Upload
                  </KenButton>
                </Grid>
              )}
              <Grid item lg={2}>
                <div style={{ marginTop: '8px ' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{
                      marginRight: '10px',
                      marginTop: '4px',
                      padding: '7px',
                      float: 'right',
                    }}
                    onClick={() => onDownloadPdf()}
                  >
                    Download
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </KenCard>
      <KenCard>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <SubjectSectionSelector
              onSelectedChange={handleSubjectChange}
              data={courseVersionData}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <Calendar
              fetchDataByTerm={fetchDataByTerm}
              defaultDate={defaultDate}
            />
          </Grid>
        </Grid>
      </KenCard>
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Download
          </Typography>
        }
        open={downloadDialog}
        handleClose={() => setDowloadDialog(false)}
        negativeButtonClick={() => setDowloadDialog(false)}
        positiveButtonClick={() => handleDownloadPdf()}
        positiveButtonText="Download"
        negativeButtonText="Cancel"
        maxWidth="lg"
        dividers
      >
        <Grid container>
          <Grid item xs={12} className="downloadMode">
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={modeDownload}
              onChange={handleDownloadermode}
              className="radio-button-group"
            >
              <FormControlLabel
                value="View"
                control={<Radio />}
                label="Download Detailed View"
              />

              <FormControlLabel
                value="Table"
                control={<Radio />}
                label="Download Consolidated List"
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </KenDialog>
    </div>
  );
}

export default function SessionScheduler() {
  const classes = useStyles();
  const [downloadDialog, setDowloadDialog] = useState(false);

  return (
    <div>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary, componentStack }) => (
          <div>
            <h1>An error occurred: {error.message}</h1>
            <button onClick={resetErrorBoundary}>Try again</button>
          </div>
        )}
      >
        <SessionSchedulerContextProvider>
          <Scheduler />
        </SessionSchedulerContextProvider>
      </ErrorBoundary>
    </div>
  );
}
